/**
 * Google-Bewertungs-Link.
 *
 * Aktiv, sobald einer der beiden Werte gesetzt ist:
 *   1. Env-Variable `NEXT_PUBLIC_GOOGLE_REVIEW_URL` (in Vercel setzen – empfohlen)
 *   2. Hardcoded-Fallback `REVIEW_URL_FALLBACK` unten im Code
 *
 * Ist keiner gesetzt, versteckt sich die ReviewPrompt-Komponente
 * automatisch, damit keine toten „Bewertung abgeben"-Buttons auf der
 * Seite stehen.
 *
 * Den Link findest du im Google Business Profile unter
 * "Bewertungen" → "Bewertungen einholen" → "Kurz-URL teilen".
 * Das Format ist typischerweise `https://g.page/r/<id>/review`.
 */

const REVIEW_URL_FALLBACK: string | null = null;

export function getGoogleReviewUrl(): string | null {
  const env = process.env.NEXT_PUBLIC_GOOGLE_REVIEW_URL;
  if (env && env.trim().length > 0) return env.trim();
  return REVIEW_URL_FALLBACK;
}

export const GOOGLE_REVIEW_URL: string | null = getGoogleReviewUrl();
